import script from "./HomeServices.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeServices.vue?vue&type=script&setup=true&lang=js"

import "./HomeServices.vue?vue&type=style&index=0&id=2241578a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2241578a"]])

export default __exports__